import api from "../service/api";

function listItems(url){
    return new Promise((resolve, reject) => {
        api().get(url).then(response => {
            if(response.status == 200 && response.data?.result)
                return resolve(response.data.data);

            reject([]);
        }).catch(error => {
            console.log(error);
            reject([]);
        });
    });
}

function deleteItem(url){
    return new Promise((resolve, reject) => {
        api().delete(url).then(response => {
            if(response.status == 200 && response.data?.result)
                return resolve(response.data.message);

            reject(response.data.message);
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

export {
    listItems,
    deleteItem
}